/* eslint-disable no-restricted-syntax */
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Form } from '@unform/web';
import { HiOutlineMinus, HiOutlinePlus } from 'react-icons/hi';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import ButtonBack from '~/components/ButtonBack';
import { Container } from './styles';
import Input from '~/components/Input';
import KrBoxes from '~/components/KoroIcons/KrBoxes';
import Signin from '~/components/Signin';
import api from '~/services/api';
import { formatPrice } from '~/utils/format';
import { useAuth } from '~/hooks/Auth';
import { IItem, useCart } from '~/hooks/Cart';
import { useMarketing, IItem as IItemMarketing } from '~/hooks/Marketing';
import ButtonHome from '~/components/ButtonHome';

interface IBatchCategory {
  id: number;
  modality_id: number;
  price: string;
  quantity: number;
  quantity_sold: number;
  batch_id: number;
  on?: boolean;
  has_age_group?: boolean;
  min_age?: number;
  max_age?: number;
  has_kit?: boolean;
  modality: {
    id: number;
    name: string;
  };
  category: {
    id: number;
    name: string;
    is_elderly?: boolean;
    is_child?: boolean;
    is_male?: boolean;
    is_female?: boolean;
    min_quantity?: number;
  };
  tickets: {
    id: number;
  }[];
  batch: {
    quantity: number;
    quantity_sold: number;
  };
}

interface IModalityEvent {
  id: number;
  modality: {
    id: number;
    name: string;
  };
}

interface ICategory {
  id: number;
  name: string;
  batchesCategories: IBatchCategory[];
  disabled: boolean;
}

interface ICategoryModality {
  id: number;
  modality_event_id: number;
  categories: ICategory[];
  modalityEvent: IModalityEvent;
}

interface IParams {
  slug: string;
  preview: string;
}

interface IQtyTicket {
  [key: string]: IItem;
}
// subir

const CheckoutCategories: React.FC = () => {
  const { trackAddToCart, setEventId: setEventIdMarketing } = useMarketing();
  const { user } = useAuth();
  const { cart, setFillBefore } = useCart();
  const { handleChangeItems } = useCart();
  const history = useHistory();
  const params = useParams<IParams>();
  const [qtyTickets, setQtyTickets] = useState({} as IQtyTicket);
  const [login, setLogin] = useState(false);
  const [eventId, setEventId] = useState<number | undefined>(undefined);
  const [batchId, setBatchId] = useState<number | undefined>(undefined);
  const [categoriesModalities, setCategoriesModalities] = useState<
    ICategoryModality[]
  >([]);

  const [errorAvailable, setErrorAvailable] = useState(false);
  const [banner, setBanner] = useState('');
  const [freePayment, setFreePayment] = useState(false);

  const isPreview = useMemo(() => !!params.preview, [params.preview]);

  const transformToCategoryModality = useCallback(
    (batchCategories: IBatchCategory[]): ICategoryModality[] => {
      const result: ICategoryModality[] = [];

      batchCategories.forEach((item) => {
        // Procura pelo objeto da modalidade
        let modalityGroup = result.find(
          (m) => m.modality_event_id === item.modality.id
        );

        // // //Se não existir ainda, cria
        if (!modalityGroup) {
          modalityGroup = {
            id: item.modality.id,
            modality_event_id: item.modality.id,
            modalityEvent: {
              id: item.modality.id,
              modality: item.modality,
            },
            categories: [],
          };
          result.push(modalityGroup);
        }

        // Procura pela categoria dentro da modalidade
        let categoryGroup = modalityGroup.categories.find(
          (c) => c.id === item.category.id
        );

        // Se não existir, cria
        if (!categoryGroup) {
          categoryGroup = {
            id: item.category.id,
            name: item.category.name,
            disabled: false,
            batchesCategories: [],
          };
          modalityGroup.categories.push(categoryGroup);
        }

        // Só adiciona o batchCategory se ainda não existir (ignore duplicados)
        const alreadyExists = categoryGroup.batchesCategories.some(
          (bc) => bc.id === item.id
        );

        if (!alreadyExists) {
          categoryGroup.batchesCategories.push(item);
        }
      });

      return result;
    },
    []
  );

  useEffect(() => {
    const eventData = localStorage.getItem('@Koro:event');
    if (eventData) {
      const parsedEvent = JSON.parse(eventData);
      if (parsedEvent.slug === params.slug) {
        setFillBefore(parsedEvent.fill_before);
        setEventId(parsedEvent.id);
        setBatchId(parsedEvent.batch_id);
        setEventIdMarketing(parsedEvent.id);
        setFreePayment(parsedEvent.free);
        if (parsedEvent.archivesEvents[0]) {
          setBanner(parsedEvent.archivesEvents[0].archive.archive_url);
        }
      } else {
        history.push(`/eventos/${params.slug}`);
      }
    } else {
      history.push(`/eventos/${params.slug}`);
    }
  }, [history, params.slug, setEventIdMarketing, setFillBefore]);

  const batchQuantityAvailable = useMemo(() => {
    return (
      categoriesModalities[0]?.categories[0]?.batchesCategories[0]?.batch
        .quantity -
      (categoriesModalities[0]?.categories[0]?.batchesCategories[0]?.batch
        .quantity_sold || 0)
    );
  }, [categoriesModalities]);

  // const loadCategoriesModalities = useCallback(async (event_id) => {
  //   const response = await api.get<IResponseCategoryModality[]>(
  //     `categories-modalities/events/${event_id}`
  //   );

  //   api.get(`apagar-cache`);

  //   const data = response.data.reduce((previous, current) => {
  //     const newData = previous.slice();
  //     const itemIndex = newData.findIndex(
  //       (categoryModality) =>
  //         categoryModality.modality_event_id === current.modality_event_id
  //     );

  //     if (itemIndex >= 0) {
  //       const batchCategory = current.category.batchesCategories.find(
  //         (batchCategoryData) =>
  //           batchCategoryData.modality_id === current.modalityEvent.modality.id
  //       );

  //       newData[itemIndex].categories.push({
  //         ...current.category,
  //         disabled: batchCategory ? !batchCategory.on : false,
  //       });
  //     } else {
  //       const batchCategory = current.category.batchesCategories.find(
  //         (batchCategoryData) =>
  //           batchCategoryData.modality_id === current.modalityEvent.modality.id
  //       );
  //       newData.push({
  //         ...current,
  //         categories: [
  //           {
  //             ...current.category,
  //             disabled: batchCategory ? !batchCategory.on : false,
  //           },
  //         ],
  //       });
  //     }

  //     return newData;
  //   }, [] as ICategoryModality[]);

  //   setCategoriesModalities(data);
  // }, []);

  const loadCategoriesModalities = useCallback(
    async (batch_id) => {
      const response = await api.get<IBatchCategory[]>(
        `batches-categories/batches/${batch_id}`
      );
      setCategoriesModalities(transformToCategoryModality(response.data));
    },
    [transformToCategoryModality]
  );

  useEffect(() => {
    if (batchId) {
      loadCategoriesModalities(batchId);
    }
  }, [batchId, loadCategoriesModalities]);

  const handleQtdKit = useCallback(
    (
      categoryId: string,
      batch_category_id: number,
      modality_id: number,
      category_id: number,
      modality: string,
      category: string,
      quantity: number,
      value: number
    ) => {
      let batchCategory: IBatchCategory | undefined;
      for (const categoryModality of categoriesModalities) {
        for (const categoryData of categoryModality.categories) {
          if (!batchCategory) {
            batchCategory = categoryData.batchesCategories.find(
              (batchCategoryData) => batchCategoryData.id === batch_category_id
            );
          }
        }
      }

      if (
        batchCategory &&
        (batchCategory.quantity === 0 ||
          batchCategory.quantity >= batchCategory.quantity_sold + quantity)
      ) {
        setQtyTickets((prev) => ({
          ...prev,
          [categoryId]: {
            batch_category_id,
            modality_id,
            category_id,
            modality,
            category,
            quantity,
            value,
          },
        }));
      }
    },
    [categoriesModalities]
  );

  const handlePlus = useCallback(
    (
      categoryId: string,
      batch_category_id: number,
      modality_id: number,
      category_id: number,
      modality: string,
      category: string,
      quantity: number,
      value: number
    ) => {
      let batchCategory: IBatchCategory | undefined;
      for (const categoryModality of categoriesModalities) {
        for (const categoryData of categoryModality.categories) {
          if (!batchCategory) {
            batchCategory = categoryData.batchesCategories.find(
              (batchCategoryData) => batchCategoryData.id === batch_category_id
            );
          }
        }
      }

      const minQty = batchCategory?.category?.min_quantity || 0;
      const newQty = quantity === 0 && minQty > 1 ? minQty : quantity + 1;

      const qtyTotal = Object.values(qtyTickets).reduce(
        (previous, current) => previous + current.quantity,
        0
      );

      const batchCategoryAvailable = Math.max(
        (batchCategory?.quantity ?? 0) - (batchCategory?.quantity_sold ?? 0),
        0
      );

      let qtdAvailable = batchQuantityAvailable - qtyTotal;

      if (batchQuantityAvailable <= 0) {
        qtdAvailable = Infinity;
      }

      if (
        qtdAvailable >= batchCategoryAvailable &&
        batchCategoryAvailable !== 0
      ) {
        qtdAvailable = batchCategoryAvailable - quantity;
      }

      if (
        qtdAvailable > 0 &&
        ((batchCategory?.quantity || 0) > quantity + 1 ||
          batchCategory?.quantity === 0)
      ) {
        setErrorAvailable(false);
      } else if (
        batchQuantityAvailable > 0 &&
        batchQuantityAvailable === qtyTotal
      ) {
        setErrorAvailable(true);
      }

      if (
        qtdAvailable > 0 &&
        ((batchCategory?.quantity || 0) >= newQty ||
          batchCategory?.quantity === 0)
      ) {
        const data = {
          [categoryId]: {
            batch_category_id,
            modality_id,
            category_id,
            modality,
            category,
            quantity: newQty,
            value,
          },
        };

        setQtyTickets((prev) => ({
          ...prev,
          ...data,
        }));
      }
    },
    [batchQuantityAvailable, categoriesModalities, qtyTickets]
  );

  const handleMinus = useCallback(
    (
      categoryId: string,
      batch_category_id: number,
      modality_id: number,
      category_id: number,
      modality: string,
      category: string,
      quantity: number,
      value: number
    ) => {
      let batchCategory: IBatchCategory | undefined;
      for (const categoryModality of categoriesModalities) {
        for (const categoryData of categoryModality.categories) {
          if (!batchCategory) {
            batchCategory = categoryData.batchesCategories.find(
              (batchCategoryData) => batchCategoryData.id === batch_category_id
            );
          }
        }
      }

      const minQty = batchCategory?.category?.min_quantity || 0;
      setErrorAvailable(false);

      let newQty: number;
      if (quantity <= 0) {
        newQty = 0;
      } else if (minQty > 0 && quantity <= minQty) {
        newQty = minQty;
      } else {
        newQty = quantity - 1;
      }

      const data = {
        [categoryId]: {
          batch_category_id,
          modality_id,
          category_id,
          modality,
          category,
          quantity: newQty,
          value,
        },
      };

      setQtyTickets((prev) => ({
        ...prev,
        ...data,
      }));
    },
    [categoriesModalities]
  );

  const handleSubmit = useCallback(() => {
    try {
      if (user) {
        const allBatchCategories = categoriesModalities
          .flatMap((cm) => cm.categories)
          .flatMap((c) => c.batchesCategories);

        const items: IItem[] = [];

        for (const item of Object.values(qtyTickets)) {
          const bc = allBatchCategories.find(
            (b) => b.id === item.batch_category_id
          );

          if (
            bc?.category.min_quantity &&
            bc.category.min_quantity > 0 &&
            item.quantity > 0 &&
            item.quantity < bc.category.min_quantity
          ) {
            Swal.fire({
              text: `A quantidade mínima para a categoria "${item.category}" é ${bc.category.min_quantity} ingresso(s).`,
              icon: 'warning',
              iconColor: '#ff6900',
              confirmButtonColor: '#ff6900',
            });
            return;
          }

          for (let i = 0; i < item.quantity; i += 1) {
            items.push({
              ...item,
              is_elderly: bc?.category.is_elderly,
              is_child: bc?.category.is_child,
              is_male: bc?.category.is_male,
              is_female: bc?.category.is_female,
              min_quantity: bc?.category.min_quantity,
              has_age_group: bc?.has_age_group,
              min_age: bc?.min_age,
              max_age: bc?.max_age,
              has_kit: bc?.has_kit,
            });
          }
        }

        if (items.length === 0) {
          throw new Error('no items');
        }

        handleChangeItems(items);

        const trackItems = items.map<IItemMarketing>((item) => ({
          id:
            item.ticket?.id.toString() ||
            `${item.batch_category_id}-${item.modality_id}`,
          name: `${item.category} - ${item.modality}`,
          quantity: item.quantity,
          price: freePayment ? 0 : item.value,
        }));

        trackAddToCart(trackItems);

        if (
          !user.additionalInformation.address &&
          !user.additionalInformation.document &&
          !user.additionalInformation.phone &&
          !user.additionalInformation.birthdate &&
          !user.additionalInformation.gender &&
          !isPreview
        ) {
          history.push(
            `${process.env.PUBLIC_URL}/eventos/${params.slug}/dados-pessoais`
          );
        } else if (cart.isFillBeforeTicket === 1) {
          history.push(
            `${process.env.PUBLIC_URL}/eventos/${params.slug}/titularidade${
              isPreview ? `/${params.preview}` : ''
            }`
          );
        } else {
          history.push(
            `${process.env.PUBLIC_URL}/eventos/${params.slug}/resumo${
              isPreview ? `/${params.preview}` : ''
            }`
          );
        }
      } else {
        setLogin(true);
      }
    } catch (error) {
      Swal.fire({
        text: 'Nenhuma categoria selecionada, escolha ao menos uma categoria',
        icon: 'warning',
        iconColor: '#ff6900',
        confirmButtonColor: '#ff6900',
      });
    }
  }, [
    cart.isFillBeforeTicket,
    categoriesModalities,
    handleChangeItems,
    history,
    isPreview,
    params.preview,
    params.slug,
    qtyTickets,
    trackAddToCart,
    user,
    freePayment,
  ]);

  const subtotal = useMemo(() => {
    if (Object.keys(qtyTickets).length > 0) {
      sessionStorage.setItem(
        `@Koro:qtyTickets_${eventId}`,
        JSON.stringify(qtyTickets)
      );
    }
    const data = Object.keys(qtyTickets).reduce((previous, current) => {
      return (
        previous + qtyTickets[current].value * qtyTickets[current].quantity
      );
    }, 0);

    return Number.isNaN(data) || freePayment ? 0 : data;
  }, [eventId, freePayment, qtyTickets]);

  useEffect(() => {
    const localQtyTickets = sessionStorage.getItem(
      `@Koro:qtyTickets_${eventId}`
    );
    if (localQtyTickets) {
      setQtyTickets(JSON.parse(localQtyTickets));
    }
  }, [eventId]);

  useEffect(() => {
    if (categoriesModalities.length === 0) return;
    setQtyTickets((prev) => {
      const next = { ...prev };
      categoriesModalities.forEach((cm) => {
        cm.categories.forEach((cat) => {
          const key = `${cm.modalityEvent.id}-${cat.id}`;
          const bc = cat.batchesCategories.find(
            (b) => b.modality_id === cm.modalityEvent.modality.id
          );
          const minQty = bc?.on ? bc?.category?.min_quantity || 0 : 0;

          if (bc && !bc.on && next[key]) {
            next[key] = { ...next[key], quantity: 0 };
          } else if (
            bc &&
            minQty > 0 &&
            (!next[key] || next[key].quantity < minQty)
          ) {
            next[key] = {
              batch_category_id: bc.id,
              modality_id: cm.modalityEvent.modality.id,
              category_id: cat.id,
              modality: cm.modalityEvent.modality.name,
              category: cat.name,
              quantity: minQty,
              value: parseFloat(bc.price),
            };
          }
        });
      });
      return next;
    });
  }, [categoriesModalities]);

  return (
    <Container banner={banner}>
      {login ? (
        <Signin signin={login} onClick={() => setLogin(false)} />
      ) : (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-11 text-center pt-3">
              <div className="d-flex justify-content-between">
                <ButtonBack className="mt-3" />
                <ButtonHome className="mt-3" />
              </div>
              <div className="banner my-3" />
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h2 className="h5 mb-0 d-flex align-items-center">
                  <KrBoxes color="#292623" size={20} className="me-2" />
                  Categorias
                </h2>
              </div>
            </div>

            <div className="col-11 px-3">
              <p>
                Escolha a(s) categoria para a(s) modalidade(s) selecionadas(s)
              </p>
              <Form onSubmit={handleSubmit}>
                {categoriesModalities.map((categoryModality) => (
                  <div key={categoryModality.id}>
                    {categoryModality.categories.some((category) =>
                      category.batchesCategories.every(
                        (batchCategory) => batchCategory.on
                      )
                    ) && (
                      <div className="bg-category p-3 mt-3">
                        <h3 className="h6 fw-semibold mb-1">
                          {categoryModality.modalityEvent.modality.name}
                        </h3>
                      </div>
                    )}
                    {categoryModality.categories.map((category) => {
                      const modalityId =
                        categoryModality.modalityEvent.modality.id;
                      const catKey = `${categoryModality.modalityEvent.id}-${category.id}`;
                      const currentBc = category.batchesCategories.find(
                        (bc) => bc.modality_id === modalityId
                      );
                      const catMinQty = currentBc?.category?.min_quantity || 0;
                      const currentQty = qtyTickets[catKey]?.quantity || 0;
                      const soldOut = !!category.batchesCategories.find(
                        (bc) =>
                          bc.modality_id === modalityId &&
                          bc?.quantity_sold &&
                          bc?.quantity !== 0 &&
                          bc?.quantity <= bc?.quantity_sold
                      );
                      return (
                        <>
                          {category.batchesCategories[0].on && (
                            <div
                              key={category.id}
                              className="bd-mod d-flex align-items-center p-2 mt-2"
                            >
                              <span>
                                <span className="text-black">
                                  {category.name}
                                </span>{' '}
                                -{' '}
                                {freePayment
                                  ? 'Gratuito'
                                  : formatPrice(
                                      parseFloat(currentBc?.price || '0')
                                    )}
                                <span className="text-danger">
                                  {!category.batchesCategories[0].on || soldOut
                                    ? ' (Esgotado)'
                                    : ''}
                                </span>
                              </span>
                              <div
                                className={`${
                                  !category.batchesCategories[0].on || soldOut
                                    ? 'opacity-50'
                                    : ''
                                } d-flex ms-auto`}
                              >
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleMinus(
                                      catKey,
                                      currentBc?.id as number,
                                      modalityId,
                                      category.id,
                                      categoryModality.modalityEvent.modality
                                        .name,
                                      category.name,
                                      currentQty,
                                      parseFloat(currentBc?.price || '0')
                                    )
                                  }
                                  className={`ms-auto pe-2 border-0 bg-transparent ${
                                    soldOut ||
                                    (catMinQty > 0 && currentQty <= catMinQty)
                                      ? 'pe-none opacity-50'
                                      : ''
                                  }`}
                                >
                                  <HiOutlineMinus
                                    size={15}
                                    color={
                                      currentQty > catMinQty
                                        ? '#292623'
                                        : '#E1E1E1'
                                    }
                                  />
                                </button>
                                <Input
                                  onChange={(
                                    e: ChangeEvent<HTMLInputElement>
                                  ) =>
                                    handleQtdKit(
                                      catKey,
                                      currentBc?.id as number,
                                      modalityId,
                                      category.id,
                                      categoryModality.modalityEvent.modality
                                        .name,
                                      category.name,
                                      parseInt(e.target.value, 10),
                                      parseFloat(currentBc?.price || '0')
                                    )
                                  }
                                  value={currentQty}
                                  type="number"
                                  name={catKey}
                                  className="qtd-kits pe-none"
                                  disabled={
                                    !category.batchesCategories[0].on ||
                                    !!category.batchesCategories.find(
                                      (bc) => bc?.quantity === bc?.quantity_sold
                                    )
                                  }
                                  min={catMinQty}
                                />
                                <button
                                  type="button"
                                  onClick={() =>
                                    handlePlus(
                                      catKey,
                                      currentBc?.id as number,
                                      modalityId,
                                      category.id,
                                      categoryModality.modalityEvent.modality
                                        .name,
                                      category.name,
                                      currentQty,
                                      parseFloat(currentBc?.price || '0')
                                    )
                                  }
                                  className={`ps-2 border-0 bg-transparent ${
                                    soldOut ? 'pe-none' : ''
                                  }`}
                                  disabled={!category.batchesCategories[0].on}
                                >
                                  <HiOutlinePlus size={15} />
                                </button>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>
                ))}
                {errorAvailable && (
                  <p className="text-danger fw-bold h6 text-center mt-3">
                    Quantidade máxima para este lote foi atingida.
                    <br />
                    Para adquirir mais ingressos, por favor faça uma nova
                    compra.
                  </p>
                )}
                <div className="d-flex justify-content-between mt-3">
                  <p className="fs-5">Subtotal:</p>
                  <p className="h5 fw-medium">{formatPrice(subtotal)}</p>
                </div>
                <button
                  type="submit"
                  className={`w-100 btn btn-login h6 fw-normal py-2 mt-3 `}
                >
                  Continuar
                </button>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default CheckoutCategories;
